import { CustomValidator } from "@rjsf/utils";
import { useMemo } from "react";

import { CreateGMNTask, EditGMNTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GmnFormProps } from "@/types/form-types";

import { useGmnUiSchema } from "../../schema/gmn-ui-schema";

import { getGmnStartRegistrationSchema } from "./schema/gmn-start-registration-schema";

export function GmnStartRegistrationForm(props: GmnFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<CreateGMNTask | EditGMNTask>({
    key: "gmn",
    task,
  });
  const schema = useMemo(
    () => getGmnStartRegistrationSchema({ type, isEditing }),
    [type, isEditing]
  );

  const uiSchema = useGmnUiSchema(formData?.metadata.qualityRegime);

  const customValidate: CustomValidator<CreateGMNTask | EditGMNTask> = (formData, errors) => {
    const date = formData?.sourcedocumentData?.startDateMonitoring;
    if (date && new Date(date) > new Date()) {
      errors["sourcedocumentData"]?.["startDateMonitoring"]?.addError(
        "Datum mag niet in de toekomst zijn"
      );
    }
    return errors;
  };

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editGMN(formData);
    } else {
      await api.createGMN(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      customValidate={customValidate}
      uploadTask={oldUploadTask}
    />
  );
}
